import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import * as React from "react";
import { toast } from "sonner";
import axiosInstance from "../../../Axios";
import useAuth from "../../../contexts/UserContext.tsx";

export default function AddTeacherModal({
  open,
  onClose,
  teacher,
  schoolName,
  schoolID,
  setReload,
  courses,
}) {
  const { user } = useAuth();
  const addModalColumn = [
    {
      field: "category_id",
      headerName: "Category ID",
    },
    {
      field: "category_name",
      headerName: "Category",
      minWidth: 250,
    },
    {
      field: "crs_title",
      headerName: "Course Title",
      minWidth: 250,
      flex: 1,
    },
  ];

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [phoneNum, setPhoneNum] = React.useState("");
  const [addCourse, setAddCourse] = React.useState([]);

  function CustomToolbarCourses() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const handleSubmit = async () => {
    if (firstName === "" || lastName === "" || phoneNum === "") {
      toast.error("Please fill all the fields");
      console.log(addCourse);
      return;
    } else if (addCourse.length === 0) {
      toast.error("Please select atleast one course");
      return;
    }
    try {
      console.log(addCourse);
      const res = await axiosInstance.post("/addSmartClassTeacher", {
        first_name: firstName,
        last_name: lastName,
        phone_num: phoneNum,
        courses: addCourse,
        school_id: schoolID,
        auth_token: user.auth_token,
      });
      if (res.data.data.status === 0) {
        throw new Error(res.data.data.msg);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setReload(true);
      handleClose();
    }
  };

  const handleClose = () => {
    setFirstName("");
    setLastName("");
    setPhoneNum("");
    onClose();
  };

  const handleAddCourseSelectionChange = (selectionModel) => {
    setAddCourse(selectionModel);
  };

  React.useEffect(() => {
    if (teacher) {
      setFirstName(teacher.firstName);
      setLastName(teacher.lastName);
      setPhoneNum(teacher.phoneNum);
    }
  }, [teacher]);

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle className="opacity-95">
          {!teacher ? "Add Teacher" : "Update Teacher"}
          <div className="text-sm opacity-60">{schoolName}</div>
        </DialogTitle>
        <DialogContent
          sx={{ display: "flex", gap: 1, flexDirection: "column" }}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="First Name"
            variant="outlined"
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Last Name"
            variant="outlined"
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Phone Num"
            variant="outlined"
            value={phoneNum}
            onChange={(event) => setPhoneNum(event.target.value)}
            size="small"
          />
          {courses &&
            (courses.length > 0 ? (
              <div className="all-course-container">
                <Typography
                  variant="h6"
                  sx={{ marginTop: "15px" }}
                  component="h2"
                >
                  All Courses
                </Typography>
                <DataGrid
                  columns={addModalColumn}
                  rows={courses}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  pagination
                  rowHeight={50}
                  sx={{ marginTop: "0.5em" }}
                  autoHeight={true}
                  getRowId={(row) => row.crs_id}
                  components={{
                    Toolbar: CustomToolbarCourses,
                  }}
                  checkboxSelection
                  onSelectionModelChange={handleAddCourseSelectionChange}
                />
              </div>
            ) : (
              <Typography variant="h6" className="text-gray-400">
                No courses available
              </Typography>
            ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: "#f45539",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#c9442d",
              },
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            {teacher === null ? "Add" : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
